import { memo } from 'react';
import { cn, LinkButton } from '@page/ui';

interface RequestDemoPromptProps {
  className?: string;
}

const RequestDemoPromptBase = ({ className }: RequestDemoPromptProps) => {
  return (
    <div className={cn('text-center mt-6 font-body-md text-text-primary font-semibold', className)}>
      Don&apos;t have an account?{' '}
      <LinkButton element="a" href="https://cal.mixmax.com/pageai/demo" target="_blank" rel="noopener noreferrer">
        Request a demo
      </LinkButton>
    </div>
  );
};

export const RequestDemoPrompt = memo(RequestDemoPromptBase);
